import { useGlobalStore } from "@hooks/useGlobalStore";
import {
	translationEn,
	translationJa,
	translationZh,
} from "@memorang/constants/i18n";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
	"en-US": { translation: translationEn },
	"zh-CN": { translation: translationZh },
	"ja-JP": { translation: translationJa },
};

const initI18n = () => {
	const { getState } = useGlobalStore;
	i18n.use(initReactI18next).init({
		compatibilityJSON: "v4",
		resources,
		lng: getState().language || "en-US",
		fallbackLng: "en-US",
		interpolation: {
			escapeValue: false,
		},
	});
};

initI18n();

export default i18n;
